interface Props {
  active: boolean;
  label: string;
}

const NetworkStatusBadge = ({ active, label }: Props) => {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium transition-colors ${
        active
          ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400"
          : "bg-muted text-muted-foreground"
      }`}
    >
      {label}
    </span>
  );
};

export default NetworkStatusBadge;
